import { useQuery } from '@tanstack/vue-query';
import { unwrapResponse } from '~/utils/unwrapResponse';

export type UseMerchantUserStatusQueryOptions = {
	merchantId: MaybeRef<string | undefined>;
};

export const fetchMerchantUserStatusFn = async (merchantId: string) => {
	const { $api } = useNuxtApp();
	return $api.GET('/merchants/{merchantId}/status', {
		params: {
			path: {
				merchantId,
			},
		},
		parseAs: 'text',
	}).then(unwrapResponse);
};

export const useMerchantUserStatusQuery = (options: UseMerchantUserStatusQueryOptions) => {
	const query = useQuery({
		queryKey: ['merchant-user-status', options.merchantId],
		queryFn: () => fetchMerchantUserStatusFn(unref(options.merchantId)!),
		retry: false,
		refetchOnMount: false,
		enabled: computed(() => !!unref(options.merchantId)),
	});

	return query;
};
